import Immutable from 'immutable';
import React from 'react';

// components
import { StepIndicator } from '../../shared/_form';
import PersonalInformation from './_PersonalInformation';
import AppointmentsAvailabilities from './_AppointmentsAvailabilities';
import AppointmentLimit from './_AppointmentLimit';
import OfficeClose from './_OfficeClose';
import SchedulingGuidelines from './_SchedulingGuidelines';
import OpeningInfo from './_OpeningInfo';
import Success from './_Success';
import { SimplePanel } from '../../shared/_panel';
import connect from 'react-redux/es/connect/connect';
import { queryParams } from '../../../lib/queryParams';

// constants
const TOTAL_STEPS = 7;

const steps = [
  PersonalInformation,
  AppointmentsAvailabilities,
  OfficeClose,
  AppointmentLimit,
  SchedulingGuidelines,
  OpeningInfo,
  Success
];

class SignUp extends React.Component {
  constructor(props) {
    super(props);

    this.state = { data: Immutable.Map() };
  }

  render() {
    return (
      <div className='body__content body__content--center'>
        <SimplePanel header='Sign Up'>
          { this._renderStep() }
          <StepIndicator currentStep={ this._getCurrentStep() } numSteps={ TOTAL_STEPS } />
        </SimplePanel>
      </div>
    );
  }

  // private

  _getCurrentStep() {
    let currentStep;

    const step = parseInt(this.props.location.query.step || 1, 10);

    if (step < 0 || step > TOTAL_STEPS) {
      currentStep = 1;
    } else {
      currentStep = step;
    }

    return currentStep;
  }

  _renderStep() {
    const { routingParams } = this.props;
    const currentStep = this._getCurrentStep();
    const stepIndex   = currentStep - 1;

    const props = {};

    props._handleGoBack = { pathname: '/managers/new', search: queryParams({ token: routingParams.token, step: routingParams.step - 1 }) };
    return React.createElement(steps[stepIndex], props);
  }
}

const mapStateToProps = (state) => ({
  routingParams: state.getIn(['routing', 'locationBeforeTransitions']).query
});

export default connect(mapStateToProps)(SignUp);



// WEBPACK FOOTER //
// ./app/components/managers/signUp/SignUp.jsx